<div class="border-container bg-white mb-3">
  <div class="header border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2 title">
        {{ "Sellers.Products.BusinessInfo" | translate }}
      </h3>
    </div>
  </div>
  <form
    [formGroup]="profileForm"
    enctype="multipart/form-data"
    *ngIf="profileForm"
  >
    <div class="p-4">
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <div>
              <label
                >{{ "Sellers.Products.BusinessName" | translate }}
                <span class="text-danger">*</span></label
              >
              <input
                readonly="true"
                class="form-control"
                type="text"
                placeholder="{{ 'Sellers.Products.BusinessName' | translate }}"
                formControlName="name"
                required
              />
            </div>
            <small *ngIf="fvBusinessInfo.formErrors.name" class="text-danger">
              {{ fvBusinessInfo.formErrors.name }}
            </small>
          </div>
          <div class="d-flex flex-column align-items-start mb-3">
            <label
              >{{ "Sellers.Products.BusinessDescription" | translate }}
              <span class="text-danger">*</span></label
            >
            <input
              class="form-control"
              placeholder="{{
                'Sellers.Products.BusinessDescription' | translate
              }}"
              cols="30"
              rows="3"
              formControlName="description"
            />
            <small
              *ngIf="fvBusinessInfo.formErrors.description"
              class="text-danger"
            >
              {{ fvBusinessInfo.formErrors.description }}
            </small>
          </div>
          <div class="form-group mb-3">
            <label
              >{{ "Sellers.Products.AveragePriceProduct" | translate }}
              <span class="text-danger">*</span></label
            >
            <input
              formControlName="averagePrice"
              type="text"
              class="form-control"
            />
            <small
              class="text-danger"
              *ngIf="fvBusinessInfo.formErrors.averagePrice"
            >
              {{ fvBusinessInfo.formErrors.averagePrice }}
            </small>
          </div>
          <div class="business-logo-container">
            <ng-container
              *ngIf="profileForm.controls['logo'].value; else elseTemplate"
            >
              <label>
                {{ "Sellers.Products.update_business_logo" | translate }}
                </label>

            </ng-container>
            <ng-template #elseTemplate>
              <label #elseTemplate>
                {{ "Sellers.Products.upload_business_logo" | translate }}
              </label>
              <br>
            </ng-template>

            <input
              #fileInput
              type="file"
              (change)="onFileInput($event)"
              accept="image/*"
              formControlName="businessLogo"
            />
            <mat-error
              *ngIf="fvBusinessInfo.formErrors.logo"
              class="text-danger d-flex"
            >
              {{ "Sellers.Products.LogoEmpty" | translate }}
            </mat-error>
          </div>
        </div>
        <div class="col-6 ml-3">
          <div class="mb-3">
            <div>
              <label
                >{{ "Sellers.Products.Category" | translate }}
                <span class="text-danger">*</span></label
              >
              <div>
                <select
                  *ngIf="categoryOptions"
                  formControlName="CategoryId"
                  class="form-control"
                >
                  <option disabled [value]="null">
                    {{ "Sellers.Products.ChooseCategory" | translate }}
                  </option>
                  <option
                    *ngFor="let option of categoryOptions"
                    [value]="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
            <small
              *ngIf="fvBusinessInfo.formErrors.CategoryId"
              class="text-danger"
            >
              {{ fvBusinessInfo.formErrors.CategoryId }}
            </small>
          </div>
          <div class="form-group mb-3">
            <label
              >{{ "Sellers.Products.DescribeProducts" | translate }}
              <span class="text-danger">*</span></label
            >
            <input formControlName="productsDescription" class="form-control" />
            <small
              class="text-danger"
              *ngIf="fvBusinessInfo.formErrors.productsDescription"
            >
              {{ fvBusinessInfo.formErrors.productsDescription }}
            </small>
          </div>
          <div class="my-3">
            <div class="d-flex flex-column align-items-start">
              <label>{{
                "Sellers.Products.CustomersNationality" | translate
              }}</label>

              <div class="d-flex">
                <mat-radio-group formControlName="customersFromEgypt">
                  <mat-radio-button [value]="'inside'" class="me-3">{{
                    "Sellers.Products.InsideEgypt" | translate
                  }}</mat-radio-button>
                  <mat-radio-button [value]="'outside'">{{
                    "Sellers.Products.OutSideEgypt" | translate
                  }}</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
